import React, {useEffect, useRef, useState} from "react";
import axios from "axios";
import Slider from "react-slick";

function FirstScreenSpeacers({slider_data}) {

    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: 1
    };

    return (
        slider_data ?
            <div className="relative">
                <div className="gallery">
                    <div className="slider-container">
                        <Slider {...settings}>
                            {
                                slider_data.map((item, value) => (
                                    <>
                                        {item.acf.big_image ?
                                            <div className="relative" key={value}>
                                                <img src={item.acf.big_image} alt={item.acf.speacer_name}
                                                     className="bottom-0 left-0 right-0 m-auto z-10 !w-auto h-[100%] max-h-[400px] sm:max-h-[540px] lg:max-h-[580px] 2xl:max-h-[610px]"/>
                                                <div
                                                    className="bg-[#E7E9EC] z-20 absolute bottom-0 right-0 p-4 flex rounded-tl-2xl w-[90%] lg:w-[100%] justify-center items-center">
                                                    <div className="w-[100px] mr-[15px]">
                                                        <img src={item.acf.logo} alt="logo" className="max-h-[50px] mx-auto" />
                                                    </div>
                                                    <div>
                                                        <h3>{item.post_title}</h3>
                                                        <p>{item.acf.position_short ? item.acf.position_short : item.acf.position }</p>
                                                    </div>
                                                </div>
                                            </div>
                                            : ''}
                                    </>
                                ))
                            }
                        </Slider>
                    </div>
                </div>
            </div>
            : ''
    )
}

export default FirstScreenSpeacers;